import { DEFAULT_LICENSE_DAYS, FORECAST_LICENSE_ID, MIDDLE_RATES_STATISTICS_ID } from "../constants/averageRates";

const STATISTICS_LICENSE_IDS = [MIDDLE_RATES_STATISTICS_ID, FORECAST_LICENSE_ID];

// Доступ к средним ставкам: «Статистика цен» (570) или «Расширенная аналитика» (592), которая её включает
export const hasStatisticsLicense = state => {
  const { isPaidUser, profile } = state;
  if (!isPaidUser || !profile?.payedServices?.services) return false;
  return profile.payedServices.services.some(
    s => STATISTICS_LICENSE_IDS.includes(s.serviceId ?? s.service_id)
  );
};

export const getLicenseDaysForButton = state => {
  const remaining = state.profile?.payedServices?.remainingDays
    ?? state.profile?.payed_services?.remaining_days;
  return remaining || DEFAULT_LICENSE_DAYS;
};

export const hasPayedServices = state =>
  !!(state.profile?.payedServices || state.profile?.payed_services);
